import React, { Component } from 'react'

import { ChromePicker } from 'react-color'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { ToolTip } from '@driftt/tide-core'

import { Swatch } from 'layouts/ColorPalette'
import * as OrgActions from 'modules/org/actions'
import * as OrgSelectors from 'modules/org/selectors'

import './style.css'

const PALETTE = [
  '#f93a1f',
  '#f4b806',
  '#00cd6a',
  '#0176FF',
  '#9b5fbc',
  '#50626a',
]

class ColorPicker extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showPicker: false,
      currentColor: props.color,
    }
  }

  static getDerivedStateFromProps(nextProps) {
    return {
      currentColor: nextProps.color,
    }
  }

  handleClick = () =>
    this.setState((prevState) => ({
      showPicker: !prevState.showPicker,
    }))

  handleChangeComplete = (color) => {
    this.props.setColor(color.hex.replace('#', ''))
  }

  handleChange = (color) => {
    this.setState({
      currentColor: color.hex,
    })
  }

  isCustomColor = () => {
    return !PALETTE.includes(`#${this.state.currentColor}`)
  }

  render() {
    const { showPicker } = this.state

    return (
      <ToolTip
        className="color-picker-touchless-tooltip"
        flow="up"
        render={() => 'Pick your own color!'}
      >
        <Swatch
          color={this.isCustomColor() ? `#${this.state.currentColor}` : '#FFF'}
          selected={this.isCustomColor()}
          className={
            !this.isCustomColor()
              ? 'color-picker-touchless-custom-swatch'
              : null
          }
          onClick={this.handleClick}
        />
        {showPicker && (
          <div className="color-picker-touchless-popover">
            <div
              className="color-picker-touchless-cover"
              onClick={this.handleClick}
            />
            <ChromePicker
              color={this.state.currentColor}
              onChange={this.handleChange}
              onChangeComplete={this.handleChangeComplete}
              disableAlpha
            />
          </div>
        )}
      </ToolTip>
    )
  }
}

const mapStateToProps = (state) => ({
  color: OrgSelectors.getColor(state),
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setColor: OrgActions.setColor,
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(ColorPicker)
